var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"flat-button",class:[_vm.size, 'bg-' + _vm.variant],attrs:{"type":_vm.type,"title":_vm.tooltip}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }